/**
 * Shared scroll position for a Birtvy web card's screenshot, keyed by NUMBER card id and stored as a FRACTION
 * (0–1) of the scrollable height — a straight port of the product's webCardScroll.ts (string ids there). A
 * fraction (not raw px) maps correctly between the small canvas card and the large fullscreen viewer, which
 * show the same screenshot at different sizes: scroll the card halfway, open it, and it lands halfway too.
 *
 * A lightweight module singleton — NOT persisted state — on purpose: scroll changes every frame while
 * scrolling, so routing it through Birtvy's save/undo would spam history + persistence. It only needs to
 * survive the live session (card ↔ fullscreen ↔ card), which a plain Map does.
 */
const scrollFractions = new Map<number, number>()

/** Read the saved scroll fraction (0–1) for a card, or 0 if none. */
export function getBirtvyWebScroll(cardId: number): number {
  return scrollFractions.get(cardId) ?? 0
}

/** Save a card's scroll fraction (clamped to 0–1). */
export function setBirtvyWebScroll(cardId: number, fraction: number): void {
  scrollFractions.set(cardId, Math.min(1, Math.max(0, fraction)))
}
